// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`Add IP form Component should match snapshot 1`] = `
<div>
  <form
    onSubmit={[Function]}
  >
    <FieldWrapper
      htmlFor="ip_address"
      style={{}}
    >
      <Component
        isRequired={true}
        label="IP Address"
        placeholder="Enter IP Address"
      />
    </FieldWrapper>
    <Component
      justify="flex-end"
      noEndGutter={true}
      style={
        {
          "marginTop": "16px",
        }
      }
    >
      <Button
        className="cancelBtn"
        onClick={[Function]}
      >
        Cancel
      </Button>
      <Button
        className="addBtn"
        type="primary"
      >
        Add IP Address
      </Button>
    </Component>
  </form>
</div>
`;
